<template lang="pug">
div(
    :class="styles.root"
    v-on:click="onClick"
)
    a(
        :class="styles.link"
        :href="href"
        target="_blank"
        rel="noopener noreferrer"
    )
    ImageSvg(
        :class="styles.logo"
        :src="`/images/banks/${logo}.svg`"
        :alt="`Логотип банка ${name}`"
        width="48"
        height="48"
    )
    TheText(
        :class="styles.name"
        name="cellTitle"
    ) {{ name }}
</template>

<script lang="ts">
import Vue, { computed, PropType, useCssModule } from 'vue'

import { sendWindowMessage } from '@/packages/send-window-message'
import { sendAppEventWithRetry } from '@/packages/namba-metrics'

import { ImageSvg } from '@/shared/ui/ImageSvg'
import { TheText } from '@/shared/ui/TheText'
import { useAppStore } from '@/shared/model'
import { yandexMetrica } from '@/shared/lib/yandex-metrica'
import { api } from '@/shared/api/rest'

import { Bank } from './model'

export type BankCellProps = Bank

export default Vue.extend({
    name: 'BankCell',
    components: { TheText, ImageSvg },
    props: {
        id: {
            type: String as PropType<BankCellProps['id']>,
            required: true,
        },
        link: {
            type: String as PropType<BankCellProps['link']>,
            required: true,
        },
        logo: {
            type: String as PropType<BankCellProps['logo']>,
            required: true,
        },
        name: {
            type: String as PropType<BankCellProps['name']>,
            required: true,
        },
        eventName: {
            type: String as PropType<BankCellProps['eventName']>,
        },
        googlePlayId: {
            type: String as PropType<BankCellProps['googlePlayId']>,
            required: true,
        },
    },
    setup({ link, eventName, googlePlayId, id, name }) {
        const styles = useCssModule()
        const { state } = useAppStore()
        const { analyticsData } = useAppStore()

        const formattedUrl = computed(() => {
            return `${link}${new URL(state.url).hash}`
        })

        const isIntentUrl = computed(() => {
            return isSamsungInternet() || isMiBrowser()
        })

        const href = computed(() => {
            return isIntentUrl.value
                ? toIntentUrl(
                      formattedUrl.value,
                      googlePlayId,
                      formattedUrl.value
                  )
                : formattedUrl.value
        })

        function onClick() {
            sendWindowMessage({
                function: 'openExternalLink',
                arguments: {
                    link: formattedUrl.value,
                },
            })
            sendBankClick()

            sendAppEventWithRetry({
                name: 'bankClick',
                bank: {
                    name,
                    link: formattedUrl.value,
                },
            })
            if (eventName) {
                // analytics.sendEvent({
                //     name: eventName,
                //     properties: {
                //         paymentLink: window.location.href,
                //         bankLink: link,
                //         qrData: analyticsData.value,
                //     },
                // })
                yandexMetrica.sendEvent({
                    name: eventName,
                    properties: {
                        paymentLink: window.location.href,
                        bankLink: link,
                        qrData: analyticsData.value,
                    },
                })
            }
        }

        async function sendBankClick() {
            try {
                await api.sendBankClick({
                    link: formattedUrl.value,
                    bankName: id,
                })
            } catch (e) {
                console.log(e)
            }
        }

        return {
            styles,
            href,
            onClick,
        }
    },
})

function isSamsungInternet() {
    return navigator.userAgent.includes('SamsungBrowser')
}

function isMiBrowser() {
    const ua = navigator.userAgent || ''
    const vendor = navigator.vendor || ''
    const platform = navigator.platform || ''

    return (
        /miuibrowser|mibrowser|miui|xiaomi/i.test(ua) ||
        /xiaomi/i.test(vendor) ||
        /xiaomi/i.test(platform)
    )
}

function toIntentUrl(
    originalUrl: string,
    packageName: string,
    fallbackUrl: string
) {
    const url = new URL(originalUrl)

    const hostAndPath = url.host + url.pathname + url.hash

    return `intent://${hostAndPath}#Intent;scheme=https;package=${packageName};S.browser_fallback_url=${encodeURIComponent(
        fallbackUrl
    )};end`
}
</script>

<style module lang="scss" src="./BankCell.module.scss" />
